import axios from 'axios';

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL;

// Hàm đăng nhập
const login = async (username, password, rememberMe) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {
      username,
      password,
      luu_mat_khau: rememberMe ? '1' : '0',
    });

    const data = response.data;

    if (response.status === 200 && data.success) {
      // Lưu thông tin người dùng vào localStorage
      localStorage.setItem('isLoggedIn', true);
      localStorage.setItem('username', data.session_data.username);
      localStorage.setItem('role', data.session_data.role);
      localStorage.setItem('name', data.session_data.name);
      localStorage.setItem('chuc_danh', data.session_data.chuc_danh);
      localStorage.setItem('luu_mat_khau', data.session_data.luu_mat_khau);
      
      return { success: true };
    } else {
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('Error during login:', error);
    return { success: false, message: 'Có lỗi xảy ra. Vui lòng thử lại.' };
  }
};

// Hàm xử lý logout
const logout = async () => {
  try {
    const response = await axios.post(`${API_URL}/logout`);

    if (response.status === 200) {
      // Xóa thông tin người dùng khỏi localStorage
      localStorage.clear();

      return { success: true, message: 'Đăng xuất thành công!' };
    } else {
      return { success: false, message: 'Đăng xuất thất bại!' };
    }
  } catch (error) {
    console.error('Error during logout:', error);
    return { success: false, message: 'Có lỗi xảy ra khi đăng xuất.' };
  }
};

// Hàm xử lý chấm công
const chamCong = async (user, timestamp, lat, lon, location, base64Image, status) => {
  try {
    const response = await axios.post(`${API_URL}/cham_cong`, {
      user,
      thoi_gian_cham_cong: timestamp,
      lat: lat,
      lon: lon,
      dia_diem_cham_cong: location,
      hinh_anh_base64: base64Image,
      loai_cham_cong: status,
    });
    if (response.status === 200 && response.data.success) {
      return { success: true, message: 'Chấm công thành công!' };
    } else {
      return { success: false, message: response.data.message || 'Chấm công thất bại!' };
    }
  } catch (error) {
    return { success: false, message: 'Có lỗi xảy ra khi chấm công. ' + error.response.data.message };
  }
};

// Hàm lấy thông tin chấm công
const getThongTinChamCong = async (month, year) => {
  try {
    const params = {};
    if (month && year) {
      params.month = month;
      params.year = year;
    }

    const response = await axios.get(`${API_URL}/thong_tin_cham_cong`, { params });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data, message: 'Tải dữ liệu chấm công thành công!' };
    } else {
      return { success: false, message: response.data.message || 'Tải dữ liệu chấm công thất bại!' };
    }
  } catch (error) {
    console.error('Error fetching attendance information:', error);
    return { success: false, message: 'Có lỗi xảy ra khi tải dữ liệu chấm công.' };
  }
};

// Hàm lấy thông tin chấm công
const getChamCongGanNhat = async () => {
  try {
    const response = await axios.get(`${API_URL}/last_cham_cong`);
    
    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data, message: 'Tải dữ liệu chấm công thành công!' };
    } else {
      return { success: false, message: response.data.message || 'Tải dữ liệu chấm công thất bại!' };
    }
  } catch (error) {
    console.error('Error fetching attendance information:', error);
    return { success: false, message: 'Có lỗi xảy ra khi tải dữ liệu chấm công.' };
  }
};

// Hàm xóa chấm công theo ID
const xoaChamCong = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/xoa_cham_cong`, { id });
    
    if (response.status === 200 && response.data.success) {
      return { success: true, message: 'Xóa dữ liệu chấm công thành công!' };
    } else {
      return { success: false, message: response.data.message || 'Xóa dữ liệu chấm công thất bại!' };
    }
  } catch (error) {
    console.error('Error deleting attendance record:', error);
    return { success: false, message: 'Có lỗi xảy ra khi xóa dữ liệu chấm công.' };
  }
};

// Hàm đổi mật khẩu
const doiMatKhau = async (matKhauCu, matKhauMoi, xacNhanMatKhauMoi) => {
  try {
    const response = await axios.post(`${API_URL}/doi-mat-khau`, {
      mat_khau_cu: matKhauCu,
      mat_khau_moi: matKhauMoi,
      xac_nhan_mat_khau_moi: xacNhanMatKhauMoi,
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, message: 'Đổi mật khẩu thành công!' };
    } else {
      return { success: false, message: response.data.message || 'Đổi mật khẩu thất bại!' };
    }
  } catch (error) {
    console.error('Error changing password:', error);
    return { success: false, message: 'Có lỗi xảy ra khi đổi mật khẩu. Vui lòng thử lại.' };
  }
};

// Đặt tên cho object trước khi export
const UserService = {
  login,
  logout,
  chamCong,
  getThongTinChamCong,
  xoaChamCong,
  doiMatKhau, // Thêm hàm đổi mật khẩu vào object export
  getChamCongGanNhat,
};

export default UserService;
